import { match, matchPath } from 'react-router'
import { createSelector } from 'reselect'
import { PeopleMembersState } from 'src/app/PeopleMembers/redux/peopleMembers.reducer'
import { userIdOption } from 'src/components/UserDropdown/UserDropdown'
import {
  organizationInfoRouteProps,
  OrganizationsMatchParams,
} from 'src/navigation/routeProps'
import { RootState } from 'src/redux/createRootReducer'
import { selectMembersListModelsFromState } from 'src/redux/selectors/data/members.selectors'
import { selectLocationFromState } from 'src/redux/selectors/router.selectors'
import { ErrorDetailMap } from 'src/utils/error.utils'

export const selectNumberOfOrgMembersFromState = (state: RootState): number =>
  state.app.organizationInfo.orgMembers.totalItems || 0

export const selectFetchSuccessFromState = (state: RootState): boolean =>
  state.app.organizationInfo.fetchSuccess
export const selectFetchFailureFromState = (state: RootState): boolean =>
  state.app.organizationInfo.fetchFailure

export const selectPatchingOrganizationsFromState = (
  state: RootState,
): boolean => state.app.organizationInfo.patchingOrganizations

export const selectPuttingOrganizationsFromState = (
  state: RootState,
): boolean => state.app.organizationInfo.puttingOrganizations

export const selectGettingReceiptRulesFromState = (state: RootState): boolean =>
  state.app.organizationInfo.gettingReceiptRules

export const selectGettingOrganizationCurrenciesFromState = (
  state: RootState,
): boolean => state.app.organizationInfo.gettingOrganizationCurrencies

export const selectSubmittingReceiptRules = (state: RootState): boolean =>
  state.app.organizationInfo.submittingReceiptRules

export const selectTopLevelReceiptRulesError = (
  state: RootState,
): string | undefined => state.app.organizationInfo.topLevelReceiptRulesError

export const selectErrorDetailMapFromState = (
  state: RootState,
): ErrorDetailMap<string> | undefined =>
  state.app.organizationInfo.errorDetailMap

export const selectOrganizationsIdFromState = createSelector(
  [selectLocationFromState],
  (location) => {
    const mtch = matchPath<OrganizationsMatchParams>(
      location.pathname,
      organizationInfoRouteProps,
    ) as match<OrganizationsMatchParams>
    return mtch.params.id
  },
)

export const selectPeopleMembers = (state: RootState): PeopleMembersState =>
  state.app.organizationInfo.orgMembers

export const selectAllPeopleMembersFromState = createSelector(
  [selectMembersListModelsFromState],
  (users) => Object.keys(users).map((id: string) => userIdOption(users[id])),
)

export const selectPatchingOrganizationApproverFromState = (
  state: RootState,
): boolean => state.app.organizationInfo.patchingOrganizationApprover
